/* global BMS*/

import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import SportsBook from './ui-modules/sports-book/containers/main';
import Simplified from './ui-modules/simplified/simplified';
import createStore from './createStore';
import {createDisabledGames, createGames} from './actions/gamesActions';
import {DISABLED_VIRTUALS, STARTING_CATEGORY, VIRTUALS} from './constants/games';
import {OPERATOR} from './constants/operator';
import {authenticatePlayer} from './helpers/authenticationHelpers';
import {handleGetStateResponse, setLoadingBar, updatePlayerBalance} from './actions/platformActions';
import {
    calculateAndSetServerTimeOffset,
    calculateServerTimeZoneOffset,
    handleGameStateChangeNotification,
    handleNMBNotification,
    handleTextNotification
} from './communications/platformMessageHandlers';
import {cssVarPoly} from './css/css-var-polyfill';
import {ALERT_NOTIFICATION} from './constants/identifiers';
import {onEventFinishedNotification, onMatchdayUpdateNotification} from "./communications/platformMessageRequests";
import {openCloseHelpPages} from "./actions/helpPagesActions";
import {gameActionHandler, isLocalStorageAvailable, muteUnmuteGame} from "./helpers/systemHelpers";

if (process.env.NODE_ENV === 'development') {
    require('./css/variables.css');
}

//apply css vars polyfill
cssVarPoly.init();

//remove any exiting bet counters on start
sessionStorage.removeItem('UNREAD_BETS');

if (isLocalStorageAvailable) {
    for (let index = 0; index < localStorage.length; index++) {
        let key = localStorage.key(index);
        if (key.includes('UNREAD_BETS')) {
            localStorage.removeItem(key);
        }
    }
}

let store = createStore();
// write on the store the initial server time offset to synchronise the count down timers from the start
if (process.env.NODE_ENV !== 'development' && BMS && BMS.initialPlattformTime) {
    calculateAndSetServerTimeOffset(BMS.initialPlattformTime, store.dispatch);
    calculateServerTimeZoneOffset(BMS.serverTimeZoneOffset, store.dispatch);
}

store.dispatch(createGames(VIRTUALS, STARTING_CATEGORY, store));
store.dispatch(createDisabledGames(DISABLED_VIRTUALS));
// create GAME object so that it can be evoked by the platform
window.GAME = {};

window.GAME.getActions = () => [];

window.GAME.openCloseHelpPages = () => store.dispatch(openCloseHelpPages());
window.GAME.muteUnmuteGame = () => muteUnmuteGame(store.dispatch);

window.GAME.postHandshake = (response) => store.dispatch(handleGetStateResponse(response, store.getState().vpp.playerUID));
window.GAME.notifyPlayer = (notificationType, title, text, isNotificationLocalizable = true, notificationWildCards = [], isDismissible = true) => handleTextNotification(notificationType, title, text, isNotificationLocalizable, notificationWildCards, isDismissible, store.dispatch);
window.GAME.onPlayerNoMoreBets = (params) => handleNMBNotification(params, store.dispatch);
window.GAME.onGameStateChange = (params) => handleGameStateChangeNotification(params, store);
window.GAME.onClosedConnection = () => window.GAME.notifyPlayer(ALERT_NOTIFICATION, 'NO_CONNECTION_TITLE', 'NO_CONNECTION_TITLE_TEXT', true, [], false);
window.GAME.onPlayerConnectedOtherPlace = () => window.GAME.notifyPlayer(ALERT_NOTIFICATION, 'NO_CONNECTION_TITLE', 'PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT', true, [], false);

window.GAME.onEventComplete = (params) => onEventFinishedNotification(params, store);
window.GAME.onMatchdayUpdate = (params) => onMatchdayUpdateNotification(params, store);

// TODO: temporary solution, remove these later -> initialize functions on GAME object to avoid errors

window.GAME.onPause = () => document.getElementById("root").style["pointer-events"] = "none";
window.GAME.onResume = () => document.getElementById("root").style["pointer-events"] = null;
window.GAME.onModalShown = () => undefined;
window.GAME.onModalHidden = () => undefined;
window.GAME.modalHidden = () => undefined;
window.GAME.onNoMoreBets = () => undefined;
window.GAME.onNewEvent = () => undefined;
window.GAME.onBetResolved = () => undefined;
window.GAME.onBetRefunded = () => undefined;
window.GAME.onEventVoid = () => undefined;
window.GAME.onMessage = () => undefined;
window.GAME.onUpdateGameState = () => undefined;
window.GAME.onReopenBetting = () => undefined;
window.GAME.onUpdateEvent = () => undefined;
window.GAME.onBalanceUpdate = (res) => store.dispatch(updatePlayerBalance(res.Balance));
window.GAME.ResponsibleGambling = {};
window.GAME.ResponsibleGambling.setRealityCheck = () => undefined;
window.GAME.handleAction = (name, value) => gameActionHandler(name, value, store);
// TODO: temporary solution, remove these later <-

window.GAME.setLoadingBar = (percentage) => store.dispatch(setLoadingBar(percentage));

let setVisibleCalled = false;

window.GAME.setVisible = (visible) => {
    if (visible) {
        document.getElementById("root").style.visibility = "visible"

        if (!setVisibleCalled) {
            BMS.Operator.setOverlayAllowed(false);
            setVisibleCalled = true;
        }
    } else {
        document.getElementById("root").style.visibility = "hidden"
    }
}


window.GAME.initUI = (profile) => undefined;

const initCompletedListeners = () => {
    authenticatePlayer(); // authenticate player on start
    let entryPoint = OPERATOR.clientType === 'Simplified'
        ? (<Simplified store={store}/>)
        : (<SportsBook store={store}/>);

    // open default game websocket
    ReactDOM.render(entryPoint, document.getElementById('root'));
};

if (process.env.NODE_ENV !== 'development') {
    BMS.initCompletedListeners.push(initCompletedListeners)
} else {
    initCompletedListeners();
}




// WEBPACK FOOTER //
// ./src/index.js